import React from 'react';
const Setting = () => <div className="p-8"><h1 className="text-2xl font-bold">Setting Page</h1></div>;
export default Setting; 